module.exports = __webpack_public_path__ + "static/media/a13_lighting.4763b4ca.png";